<div class="container mt-4">
  <div class="row">
    <!-- Social Media Card -->
    <div class="col-md-6 mb-4">
      <div class="card h-100">
        <div class="card-header">
          <h4>Social-Media-Konten</h4>
        </div>
        <div class="card-body">
          <button class="btn btn-primary mb-3" (click)="openSocialMediaModal()">Social Media hinzufügen</button>
          <ul class="list-group">
            <li class="list-group-item d-flex align-items-center" *ngFor="let account of socialMediaAccounts">
              <i class="{{ sharedService.getPlatformIcon(account.platform) }} me-2"></i>
              <span>{{ account.platform }}: <a [href]="account.url" target="_blank">{{ account.url | slice:0:20 }}{{ account.url.length > 20 ? '...' : '' }}</a></span>
              <div class="ms-auto">
                <button class="btn btn-sm btn-link text-secondary me-2" (click)="openSocialMediaModal(account)">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn btn-sm btn-link text-danger" (click)="deleteSocialMedia(account.id)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Company Information Card -->
    <div class="col-md-6 mb-4">
      <div class="card h-100">
        <div class="card-header">
          <h4>Unternehmensinformationen</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="companyInfoForm">
            <div class="mb-3">
              <label for="email" class="form-label">E-Mail</label>
              <input type="email" class="form-control" id="email" formControlName="email" required>
              <div *ngIf="companyInfoForm.get('email')?.invalid && companyInfoForm.get('email')?.touched" class="text-danger">
                <div *ngIf="companyInfoForm.get('email')?.hasError('required')">E-Mail ist erforderlich</div>
                <div *ngIf="companyInfoForm.get('email')?.hasError('email')">Ungültiges E-Mail-Format</div>
              </div>
            </div>
            <div class="mb-3">
              <label for="address" class="form-label">Adresse</label>
              <input type="text" class="form-control" id="address" formControlName="address" required>
              <div *ngIf="companyInfoForm.get('address')?.invalid && companyInfoForm.get('address')?.touched" class="text-danger">
                Adresse ist erforderlich
              </div>
            </div>
            <div class="mb-3">
              <label for="phoneNumber" class="form-label">Telefonnummer</label>
              <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber" required>
              <div *ngIf="companyInfoForm.get('phoneNumber')?.invalid && companyInfoForm.get('phoneNumber')?.touched" class="text-danger">
                Telefonnummer ist erforderlich
              </div>
            </div>
            <button type="button" class="btn btn-primary" [disabled]="companyInfoForm.invalid" (click)="saveCompanyInfo()">Aktualisieren</button>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Social Media Modal -->
  <div class="modal" id="socialMediaModal" tabindex="-1" [ngClass]="{'show d-block': showSocialMediaModal}" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditMode ? 'Bearbeiten' : 'Hinzufügen' }} Social-Media-Konto</h5>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="socialMediaForm">
            <div class="mb-3">
              <label for="platform" class="form-label">Plattform</label>
              <select class="form-select" id="platform" formControlName="platform" required>
                <option value="" disabled>Plattform auswählen</option>
                <option *ngFor="let platform of platforms" [value]="platform">{{ platform }}</option>
              </select>
              <div *ngIf="socialMediaForm.get('platform')?.invalid && socialMediaForm.get('platform')?.touched" class="text-danger">
                Plattform ist erforderlich
              </div>
            </div>
            <div class="mb-3">
              <label for="url" class="form-label">URL</label>
              <input type="text" class="form-control" id="url" formControlName="url" required>
              <div *ngIf="socialMediaForm.get('url')?.invalid && socialMediaForm.get('url')?.touched" class="text-danger">
                URL ist erforderlich
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">Schließen</button>
          <button type="button" class="btn btn-primary" [disabled]="socialMediaForm.invalid" (click)="saveSocialMedia()">
            {{ isEditMode ? 'Aktualisieren' : 'Hinzufügen' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>